import script from "./ProjectsGrid.vue?vue&type=script&setup=true&lang=js"
export * from "./ProjectsGrid.vue?vue&type=script&setup=true&lang=js"

import "./ProjectsGrid.vue?vue&type=style&index=0&id=83bcd7fe&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-83bcd7fe"]])

export default __exports__